module.exports = __webpack_public_path__ + "img/camionnette.c5da9ca3.jpg";